import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import GameView from "@/views/game/GameView.vue";
import { useGameStore } from "@/stores/gameStore";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import ShowErrorLoading from "@/views/ShowErrorLoading.vue";
import { useUserInfoStore } from "@/stores/userInfoStore";
import { watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GamePresenter',
  setup(__props) {

const gameStore = useGameStore();
const { error, waitingMessage, isGameOver, gameMode } = storeToRefs(gameStore);
const { setErrorMessage } = gameStore;

const userStore = useUserInfoStore();
const { loggedIn } = storeToRefs(userStore);

const id = useRouter().currentRoute.value.params.id as string;

watch(
  () => loggedIn.value,
  (newVal) => {
    console.log("new log in, ", newVal);
    if (!newVal && gameMode.value !== "local") {
      setErrorMessage("Need to be logged in to play online...");
      return;
    }
    setErrorMessage(null);
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ShowErrorLoading, {
      "waiting-message": _unref(waitingMessage),
      error: _unref(error)
    }, null, 8, ["waiting-message", "error"]),
    (!_unref(waitingMessage) && !_unref(error))
      ? (_openBlock(), _createBlock(GameView, {
          key: 0,
          "is-game-over": _unref(isGameOver),
          "is-local-game": _unref(id) === 'local'
        }, null, 8, ["is-game-over", "is-local-game"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})